<template>
  <div>
    <block-title class="block-title" title="其他信息">
      <form-item
        form-fef="otherInfo"
        :form="form"
        :rules="rules"
        v-bind="$attrs"
        :field-list="fieldList"
      />
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import FormItem from './FormItem.vue'
import { OTHERFIELDLIST } from '../constant'
import { getCarType } from '../../api'

export default {
  name: 'OtherInfo',
  components: {
    BlockTitle,
    FormItem
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rules: {},
      fieldList: OTHERFIELDLIST,
    }
  },
  created() {
    this.getCarType()
  },
  methods: {
    async getCarType() {
      const res = await getCarType({
        pageSize: '999'
      })
      const carTypeList = res.map(item => {
        return {
          value: item.carSettingName,
          label: item.carSettingName
        }
      })
      this.fieldList[3].list = carTypeList
    }
  }
}
</script>